import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Form } from '../../data/form';
import { Subscription } from 'rxjs';
import { WebSocketService } from '@rbb/ng-web-socket-lib';
import { ActivatedRoute } from '@angular/router';
import { FormComponent } from '../form/form.component';

@Component({
  selector: 'app-editor-websocket',
  templateUrl: './editor-websocket.component.html',
  styleUrl: './editor-websocket.component.css',
  imports: [FormComponent]
})
export class EditorWebsocketComponent implements OnInit, OnDestroy {
  private webSocketService = inject(WebSocketService);
  private route = inject(ActivatedRoute);

  id: string | undefined;

  socketStatus = false;
  socketStatusSubscription: Subscription | undefined;

  previewForm: Form | undefined;

  ngOnInit(): void {
    this.id = this.route.snapshot.params['id'];

    if (this.id) {
      this.socket();
      this.socketStatusSubscription = this.webSocketService.getOpenStateChanged().subscribe(
        (status: boolean) => {
          this.socketStatus = status;
        }
      );
      this.socketStatus = this.webSocketService.isOpen();
    }
  }

  ngOnDestroy(): void {
    this.webSocketService.unsubscribeType('registration-' + this.id);
    this.socketStatusSubscription?.unsubscribe();
    this.socketStatusSubscription?.unsubscribe();
  }

  socket(): void {
    this.webSocketService.subscribeType('registration-' + this.id).subscribe(
      (webSocketMessage: Form) => {
        this.previewForm = webSocketMessage;
      }
    );
  }
}
